export const parseScramble = (s: string): string[] =>
    s.trim().split(/\s+/);